/** @format */

import React from 'react';
import { Row, Col } from 'antd';
import { MajorMedInfo } from '../types';

interface MajorMedFormProps {
  data: MajorMedInfo;
  onChange: (field: keyof MajorMedInfo, value: any) => void;
  isAcaRequest?: boolean;
}

export const MajorMedForm: React.FC<MajorMedFormProps> = ({ data, onChange, isAcaRequest = false }) => {
  return (
    <Col sm={24} md={24} lg={24} xl={24}>
      <Row gutter={[24, 24]}>
        <Col sm={24} md={24} lg={24} xl={24}>
          <div className='form-heading'>
            <span> Major Medical Plan Information</span>
          </div>
        </Col>
        
        <Col sm={24} md={24} lg={24} xl={24}>
          <div className='form-input-wrapper'>
            <label>Carrier*</label>
            <input
              type='text'
              id='carrier-input'
              name='majorMed.carrier'
              value={data.carrier}
              onChange={(e) => onChange('carrier', e.target.value)}
              required
            />
          </div>
        </Col>

        {/* Only show "Was customer charged today?" if NOT ACA request */}
        {!isAcaRequest && (
          <Col sm={24} md={24} lg={24} xl={24}>
            <div className='form-input-wrapper'>
              <span>Was the customer charged today? *</span>
              <div className='radial-input-wrapper'>
                <label>
                  <input
                    type='radio'
                    name='majorMed.isPostDate'
                    value='false'
                    checked={data.isPostDate === false}
                    onChange={() => onChange('isPostDate', false)}
                  />
                  Yes
                </label>
                <label>
                  <input
                    type='radio'
                    name='majorMed.isPostDate'
                    value='true'
                    checked={data.isPostDate === true}
                    onChange={() => onChange('isPostDate', true)}
                  />
                  No
                </label>
              </div>
            </div>
          </Col>
        )}

        <Col sm={24} md={24} lg={12} xl={12}>
          <div className='form-input-wrapper'>
            <label>
              {isAcaRequest
                ? 'Enter Requested Billing Date*'
                : data.isPostDate
                ? 'Enter Billing Date*'
                : "Enter Today's Date*"}
            </label>
            <input
              style={{ width: '100%' }}
              type='date'
              name='majorMed.billingDate'
              value={data.billingDate}
              onChange={(e) => onChange('billingDate', e.target.value)}
              required
            />
          </div>
        </Col>

        <Col sm={24} md={24} lg={12} xl={12}>
          <div className='form-input-wrapper'>
            <label>Total Premium</label>
            <input
              style={{ width: '100%' }}
              type='number'
              name='majorMed.premium'
              value={data.premium}
              onChange={(e) => onChange('premium', parseFloat(e.target.value) || 0)}
              required
            />
          </div>
        </Col>
      </Row>
    </Col>
  );
};
